<template>
  <div class="pdf-box">
    <img src="../assets/capa_livro_padrao.jpeg" alt="Capa do PDF" class="pdf-cover" />

    <div class="pdf-info">
      <span class="pdf-title">{{ book.nome_arquivo }}</span>

      <div class="btn-group">
        <!-- Ler Livro: envia para /book com amd e hash -->
        <router-link
          class="pdf-link"
          :to="{
            path: '/book',
            query: { amd: book.amd_arq_pdf_aula, hash: book.hash_arq_pdf_aula }
          }"
        >
          Ler Livro
        </router-link>

        <!-- Abrir Livro: só aparece se pdfUrl estiver carregado -->
        <a
          v-if="pdfUrl"
          :href="pdfUrl"
          target="_blank"
          rel="noopener"
          class="pdf-link"
        >
          Baixar Livro
        </a>

        <!-- Mensagem enquanto carrega -->
        <span v-else class="carregando">Preparando arquivo...</span>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/CardBook.css';
import request, { Url } from '../router/request';

export default {
  name: 'CardBook',
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      pdfUrl: "",
      showModal: false,
      modalMessage: ""
    };
  },
  methods: {
    async viewBook(book) {
      try {
        const response = await request.post('/arquivo/prepararDownload', {
          ano_mes_dia_arq: book.amd_arq_pdf_aula,
          hash_arquivo: book.hash_arq_pdf_aula
        });

        const hashValido = response?.data?.hash || book.hash_arq_pdf_aula;
        this.pdfUrl = `${Url}/arquivo/download?hash=${hashValido}`;
      } catch (error) {
        console.error('Erro ao preparar o PDF:', error);
        this.modalMessage = 'Erro ao preparar visualização do PDF.';
        this.showModal = true;
      }
    }
  },
  mounted() {
    this.viewBook(this.book);
  }
};
</script>

